export default __webpack_public_path__ + "static/media/dirtfloor.e746a70c.png";